module.exports = __webpack_public_path__ + "img/domik_dark_logo.b7fcc526.svg";